import { connect } from 'react-redux';

import { showModal } from '../../../core/actions';
import FeeHeader from './FeeHeader';


export default connect(null, { openModal: showModal })(FeeHeader);
